/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Export_Font_Size_LabelInputs */



/**
* | output |
* | --- |
* | "Size" |
*
* @param {Image_Export_Font_Size_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_font_size_label = /** @type {((inputs?: Image_Export_Font_Size_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_Font_Size_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Taille")
	if (locale === "de") return /** @type {LocalizedString} */ ("Größe")
	if (locale === "it") return /** @type {LocalizedString} */ ("Misurare")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Размер")
	if (locale === "es") return /** @type {LocalizedString} */ ("Tamaño")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("尺寸")
	if (locale === "ja") return /** @type {LocalizedString} */ ("サイズ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("आकार")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Tamanho")
	return /** @type {LocalizedString} */ ("Size")
});